import AppLayout from './components/AppLayout'
import DemograficiSection from './components/DemograficiSection'

export default function App() {
  return (
    <AppLayout>
      {({ selectedAmbito, onSelectedAmbitoChange }) => (
        <>
          <section className="telemetry-dashboard">
            <div className="telemetry-inner">
              <DemograficiSection
                selectedAmbitoId={selectedAmbito}
                compareAmbiti={false}
                onSelectedAmbitoChange={onSelectedAmbitoChange}
              />
            </div>
          </section>

          {/* Nuova sezione Comparazione tra ambiti */}
          <section className="telemetry-dashboard telemetry-dashboard--compare" style={{ marginTop: 48 }}>
            <div className="telemetry-inner">
              <h2 className="telemetry-section-title" style={{ marginBottom: 16 }}>Comparazione tra ambiti</h2>
              <DemograficiSection
                selectedAmbitoId={null}
                compareAmbiti={true}
                onSelectedAmbitoChange={() => {}}
              />
            </div>
          </section>
        </>
      )}
    </AppLayout>
  )
}
